/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, {
  useState, useRef, useEffect, useCallback, useLayoutEffect, useMemo,
} from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { useTheme } from 'emotion-theming';
import Shimmer from '../../../../shared/_TBComponents/Shimmer';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';
import { normalizeSupersetColor } from '../../../../shared/constants';

import Text from '../../../../shared/components/Text/Text';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import ExerciseTable from './ExerciseTable';
import ExerciseTableTransposed from './ExerciseTableTransposed';
import CalendarItemDropdownOptions from './CalendarItemDropdownOptions';
import PreSaveTable from './PreSaveTable';
import PreSaveTableTransposed from './PreSaveTableTransposed';
import {
  removePresaveItemFromRedux,
  removePresaveProgramItemFromRedux,
  setActiveModal,
  removeSelectedItem,
  setSelectedItem,
  setSelectedItems,
  updateCalendarItemsOrder,
  updateWorkoutItemsOrder,
  setCalendarItems,
  setNonDateBasedProgramItems,
  setSuperSetPickerOpenById,
  removeSuperSetPickerOpenById,
  setPreSaveTableLocalState,
  setActiveExerciseId,
  setSwapDropdownToggleEnabled,
} from '../../ducks/calendarActions';
import PreSaveTableSAQC from './PreSaveTableSAQC';
import PreSaveTableTransposedSAQC from './PreSaveTableTransposedSAQC';
import ExerciseTableSAQC from './ExerciseTableSAQC';
import ExerciseTableTransposedSAQC from './ExerciseTableTransposedSAQC';
import ExerciseTableCircuit from './ExerciseTableCircuit';
import ExerciseTableTransposedCircuit from './ExerciseTableTransposedCircuit';
import PreSaveTableCircuit from './PreSaveTableCircuit';
import PreSaveTableTransposedCircuit from './PreSaveTableTransposedCircuit';
import hexToRgba from '../../../../shared/utils/hexToRgba';
import decodeHtmlEntities from '../../../../shared/utils/decodeHtmlEntities';
import getExerciseInfoCategory from '../../../../shared/utils/getExerciseInfoCategory';
import getModifierKeyLabel from '../../../../shared/utils/getModifierKeyLabel';
import buildBothInfoText from '../../utils/buildBothInfoText';
import isNonSwappedParentItem from '../../utils/isNonSwappedParentItem';
import useExerciseOptionToggles from '../../hooks/useExerciseOptionToggles';
import {
  EXERCISE_OPTIONS,
  getDefaultExerciseOptions,
  resolveExerciseContentType,
} from '../../constants/exerciseOptions';
import QuestionnaireTable from './QuestionnaireTable';
import WarmupTable from './WarmupTable';
import NoteTable from './NoteTable';
import HealthTable from './HealthTable';
import CooldownTable from './CooldownTable';
import SessionBreakTable from './SessionBreakTable';
import RestTimeTable from './RestTimeTable';
import PreSaveRestTimeTable from './PreSaveRestTimeTable';
import PreSaveVideoTable from './PreSaveVideoTable';
import VideoTable from './VideoTable';
import PreSaveProgressionTable from './PreSaveProgressionTable';
import ProgressionTable from './ProgressionTable';
import TagTable from './TagTable';
import TagTableTransposed from './TagTableTransposed';
import SelectDropdownExercisePicker from './SelectDropdownExercisePicker';
import MobileAddExercisePicker from './MobileAddExercisePicker';
import SuperSetPickerPopup from './SuperSetPickerPopup';
import { flushDebounceForTable } from './hooks/debounceHandler';
import useDetachedTouchBridge from './hooks/useDetachedTouchBridge';
import useTabCyclesWithinItem from '../../hooks/useTabCyclesWithinItem';
import useIsMobile from '../../../../shared/hooks/useIsMobile';
import { formatPaceLabel } from '../../utils/pacingPercentages';
import themedScrollbar from './themedScrollbar';

const Container = styled('div')`
  position: relative;
  background-color: ${(props) => (props.isActive ? 'rgba(0, 0, 0, 0.02)' : 'transparent')};
  transition: background-color 0.15s ease;
`;

const ItemRow = styled('div')`
  display: flex;
  position: relative;
  padding-top: 8px;
  padding-bottom: 8px;
  align-items: center;
  margin-left: ${(props) => (props.isWeekView ? '8px' : '0px')};
  margin-right: ${(props) => (props.isWeekView ? '8px' : '0px')};
`;

/** Seals the whole item row while it is mid-operation — a swap or a save in
 * flight — so nothing in it can be clicked. ItemRow is position: relative with
 * no fixed height, and its LineContainer holds the chrome (title, quick
 * actions, kebab) AND the pre-save table as column siblings, so 100%/100% here
 * covers all of it. Placing this inside PreSaveExpandingContainer instead would
 * cover only the table.
 *
 * z-index clears AbsolutelyPositionedCheckBoxClickArea's inline 999; neither
 * ItemRow nor LineContainer creates a stacking context, so they compare
 * directly. */
const ItemLockOverlay = styled('div')`
position: absolute;
display: flex;
height: 100%;
width: 100%;
top: 0;
left: 0;
cursor: not-allowed;
/** Swaps dim the row. Saves don't: the shimmering table already reads as busy,
 * and a scrim over the top of it only muddies the animation. A scrim, not a
 * panel: the locked exercise must stay visible underneath. Dark dims with the
 * black overlay token; light keeps its translucent white. */
background: ${({ dim, theme }) => {
    if (!dim) return 'transparent';
    return theme.isDark ? theme.colors.overlayMedium : 'rgba(255, 255, 255, 0.6)';
  }};
z-index: 2000;
`;

const LineContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: ${(props) => (props.isTvMode ? '15px' : '10px')};
  width: 100%;
  overflow-x: hidden;
`;

const Line = styled('div')`
  position: absolute;
  left: ${(props) => {
    if (props.isTvMode) return '48px';
    if (props.isWeekView || props.omitCheckbox) return '38px';
    return '63px';
  }};
  top: ${(props) => (props.doesGroupingLetterAboveItemMatchContent && !props.isDragging && !props.isHovered ? '0' : '8px')};
  bottom: ${(props) => (props.doesGroupingLetterBelowItemMatchContent && !props.isDragging && !props.isHovered ? '0' : '8px')};
  width: 2px;
  background-color: ${(props) => props.color || '#E74C3C'};
`;

const AbsolutelyPositionedCheckBoxClickArea = styled('div')`
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  width: 62px;
`;

const TextColumn = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  margin-left: ${(props) => (props.isPopover ? '0' : '7px')};
  position: relative;
`;

const Subtext = styled('div')`
  overflow: hidden;
  font-size: ${(props) => (props.isTvMode ? '14px' : '12px')};
  color: ${({ theme }) => theme.colors.text};
  font-family: 'Nunito Sans';
  cursor: default;
`;

const SubTitle = styled('div')`
  overflow: hidden;
  font-size: ${(props) => (props.isTvMode ? '14px' : '12px')};
  color: ${({ theme }) => theme.colors.text};
  font-family: 'Nunito Sans';
`;

const ExpandingContainer = styled('div')`
  padding-left: ${(props) => (props.isPopover ? '0' : '7px')};
  padding-right: 7px;
  max-width: 100%;
  overflow: hidden;

    ${themedScrollbar}
`;

const PreSaveExpandingContainer = styled('div')`
  display: flex;
  padding-left: ${(props) => (props.isPopover ? '0' : '7px')};
  padding-right: 7px;
  max-width: 100%;
  overflow: hidden;

    ${themedScrollbar}
`;

const NameText = styled('div')`
  font-size: ${(props) => (props.isTvMode ? '18px' : '16px')};
  font-weight: ${(props) => (props.isTvMode ? '700' : 'normal')};
  color: ${({ theme }) => theme.colors.text};
  font-family: 'Nunito Sans';
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const NameTextAndDownArrowContainer = styled('div')`
display: flex;
gap: 5px;
cursor: pointer;
align-items: center;
max-width: ${(props) => props.maxWidth && props.maxWidth + 20}px;
`;

const RedDashThrough = styled.div`
  width: 24px;
  height: 2px;
  background: ${({ theme }) => theme.colors.textTertiary};
  position: absolute;
  transform: rotate(45deg);
  transform-origin: center;
  left: -1px;
  top: 8px;
`;

const IconContainer = styled('div')`
  position: relative;
  background: ${(props) => props.background};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${(props) => (props.isTvMode ? '35px' : '24px')};
  min-width: ${(props) => (props.isTvMode ? '35px' : '24px')};
  max-width: ${(props) => (props.isTvMode ? '35px' : '24px')};
  max-height: ${(props) => (props.isTvMode ? '35px' : '24px')};
  /* Fill only, no border: the design's icon chip is a 24px 20%-tint square with
   * a 16px glyph. The old 1px border in the same tint softened the edge and
   * read as a bigger, paler chip. */
  border: none;

  ${(props) => props.isMobileDragHandle && `
    @media (max-width: 480px) {
      /* load-bearing: the icon is the rbd drag handle on phones - it must own
         the touch gesture so native scrolling can't cancel the long-press
         lift, and it must sit above the absolute checkbox click overlay
         (z-index 999) so touches actually reach it */
      touch-action: none;
      -webkit-touch-callout: none;
      -webkit-tap-highlight-color: transparent;
      user-select: none;
      -webkit-user-select: none;
      z-index: 1000;
    }
  `}
`;

const ParentOrSwapIcon = styled('div')`
  position: absolute;
  top: -9px;
  left: -7px;
  height: 16px;
  width: 16px;
  background: #B5B5B5;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
`;

const DeletedItemIcon = styled('div')`
  position: absolute;
  top: -8px;
  left: -7px;
  height: 18px;
  width: 18px;
  background: #eee787ff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
`;

const ParentIconBorderBox = styled('div')`
  border: 1px solid ${({ theme }) => theme.colors.white};
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 12px;
  width: 12px;
  text-align: center;
`;

const IconAndCheckBoxContainer = styled('div')`
display: flex;
height: 100%;
align-self: self-start;
gap: ${(props) => (props.isWeekView ? '0px' : '8px')};
margin-left: 2px;
.checkbox-input {
    visibility: ${(props) => !props.checkboxVisible && 'hidden'};
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid ${(props) => (props.isChecked ? props.theme.colors.link : props.theme.colors.borderMedium)};
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
    z-index: 10;
  }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: solid ${(props) => (props.isChecked ? props.theme.colors.link : props.theme.colors.borderMedium)};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const InLineActionsIconContainer = styled('div')`
  display: flex;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  height: 32px;
  width: 32px;
  min-width: 32px;
  align-items: center;
  justify-content: center;
  :hover {
    background: ${(props) => (props.isDeleteIcon ? 'rgba(255, 5, 5, 0.2)' : 'rgba(119, 167, 255, 0.2)')};
  }

  .inLineActionsIcons {
    fill: ${({ theme }) => theme.colors.textSecondary};
  }

  &:hover .inLineActionsIcons  {
    fill: ${(props) => (props.isDeleteIcon ? '#FF0505' : props.theme.colors.hover)};
  }

`;

const RightBox = styled('div')`
  display: flex;
`;

const RightBoxPlaceholder = styled('div')`
  display: flex;
  visibility: hidden;
`;

const DescriptionText = styled('div')`
  display: flex;
  width: 100%;
`;

const AddDescriptionButton = styled('div')`
  display: flex;
  color: ${({ theme }) => theme.colors.link};
  font-weight: 700;
  cursor: pointer;
`;

const EditDescriptionButton = styled('div')`
  display: flex;
  color: ${({ theme }) => theme.colors.link};
  font-weight: 700;
  cursor: pointer;
  display: inline;
  white-space: nowrap;
  margin-left: 5px;
  width: fit-content;
`;

const additionalInfoShortcutLabel = `(${getModifierKeyLabel()} + I)`;

const TextInfoColumn = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const IconBox = styled('div')`
  display: flex;
   gap: 3px;
`;

const ClickContainer = styled('div')`
  min-height: 32px;
  padding-bottom: ${(props) => props.addPaddingBottom && '5px'};
  display: flex;
  overflow: hidden;
  transition: height 0.3s ease;
  justify-content: space-between;
  align-items: center;
  .rc-menu {
    padding: 10px;
  }
  padding-top: ${(props) => props.isSuperSet && '5px'};
  padding-bottom: ${(props) => (props.type === 'progression' || props.type === 'P') && props.isExpanded && '5px'}
`;

const ShimmerDescription = styled('div')`
  width: 100%;
  max-width: 400px;
  height: 20px;
  border-radius: 4px;
`;

const ConditionalScrollContainer = styled('div')`
  display: flex;
  width: 100%;

    ${themedScrollbar}
`;

const MenuWrapper = styled('div')`
  .custom-rc-menu {
    border-radius: 4px !important;
    box-shadow: 0px 4px 8px 0px #3031331A !important;
    border: 1px solid ${({ theme }) => theme.colors.borderLight} !important;
  
    ${themedScrollbar}
  }
`;

const AbsoluteText = styled('div')`
  position: absolute;
  top: -22px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #5F8BDC;
  font-family: Nunito Sans;
  font-weight: 600;
  font-size: 12px;
  z-index: 5;
`;

const DraggableContent = ({
  localDescription,
  setLocalDescription,
  localAdditionalInfo,
  setLocalAdditionalInfo,
  measure,
  content,
  isHovered,
  itemIsHoveredByMouse,
  itemHoveringOverCurrentItem,
  index,
  isExpanded,
  setIsExpanded,
  checkboxVisible,
  isRecurring,
  beforeOrAfter,
  isDragging,
  shouldShowQuickActions,
  isWeekView,
  isDayExpanded,
  date,
  dayNumber,
  onDayExpand,
  isAthleteAddedItem,
  readOnlyInheritedRecurringItem,
  athleteAddedItems,
  omitCheckbox,
  onPopoverClose,
  flags,
  /** rbd dragHandleProps, passed only on phones where the type icon acts as
   * the drag handle (null/undefined elsewhere - spread is then a no-op) */
  dragHandleProps,
}) => {
  const expandingContainerRef = useRef(null);
  const contentRef = useRef(null);
  const exercisePickerTextRef = useRef(null);
  const itemRowRef = useRef(null);
  const inLineActionsContainerRef = useRef(null);
  const textWrapperRef = useRef(null);
  const clickContainerRef = useRef(null);
  /** keeps touch events flowing to rbd after it unmounts the original item
   * at lift (cloning API) - see the hook for details */
  const dragHandleTouchBridgeRef = useDetachedTouchBridge(!!dragHandleProps);
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const store = useStore();
  const isSwapLoading = useSelector(
    (state) => !!state.calendar.ui.swapLoadingAssignedIds[content?.assignedId],
  );
  /** Per-item, keyed on assignedId — deliberately not the global
   * isCalendarItemSaving, which is a single value shared by every save.
   * Written on the save thunk's _START, cleared on both _FULFILLED and _REJECTED. */
  const isSavingThisItem = useSelector(
    (state) => !!state.calendar.ui.savingAssignedIds[content?.assignedId],
  );
  /** One flag for "this item is mid-operation, keep hands off it". An in-flight
   * save has no server id yet, so acting on the item now targets something that
   * doesn't exist — deleting mid-save strands the saved item outside Redux
   * entirely. Drag is already blocked upstream in DraggableDivWrapper. */
  const isItemLocked = isSwapLoading || isSavingThisItem;
  const selectedItem = useSelector((state) => (state.calendar.data.selectedItems[content.assignedId]));
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const preSaveAddInfo = useSelector((state) => state.calendar.data.preSaveAddInfo);
  const preSaveDescription = useSelector((state) => state.calendar.data.preSaveDescription);
  const activeModal = useSelector((state) => state.calendar.data.activeModal);
  const isTvMode = useSelector((state) => state.calendar.ui.isTvMode);
  const isCalendarItemUpdating = useSelector((state) => state.calendar.ui.isCalendarItemUpdating);
  const calendarItemIndexBeingUpdated = useSelector((state) => state.calendar.ui.itemIndexBeingUpdated);
  /** Save side is per item. The global isCalendarItemSaving / itemIndexBeingSaved
   * are single values, so with overlapping saves the shimmer landed on whichever
   * row held the last-started index and cleared when the first save finished. */
  const isCalendarItemSavingOrUpdating = isSavingThisItem || (isCalendarItemUpdating && calendarItemIndexBeingUpdated === index);
  const programType = useSelector((state) => state.calendar.data.programType);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const isThisItemSupersetPickerOpen = useSelector(
    (state) => !!state.calendar.data.isSupersetPickerOpen[content.assignedId],
  );
  const preSaveBackup = useSelector(
    (state) => state.calendar.data.preSaveTableLocalState[content.assignedId],
  );
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const effectiveDate = date || selectedDate;
  const effectiveSelectedProgramDayNumber = dayNumber || selectedProgramDayNumber;
  const endpointFormattedDate = useMemo(
    () => (effectiveDate ? moment(effectiveDate).format('YYYY-MM-DD') : null),
    [effectiveDate],
  );
  const EMPTY_EXERCISES = useRef([]).current;
  const nonDateCalendarItems = useSelector(
    (state) => state.calendar.data.nonDateBasedProgramItems[
      effectiveSelectedProgramDayNumber
    ]?.exercises || EMPTY_EXERCISES,
  );
  const dateCalendarItems = useSelector(
    (state) => (endpointFormattedDate
      ? state.calendar.data.calendarItems[endpointFormattedDate]?.exercises || EMPTY_EXERCISES
      : EMPTY_EXERCISES),
  );
  const calendarItems = programType === 'free-form-program' ? nonDateCalendarItems : dateCalendarItems;
  const beforeRecurringWorkouts = useSelector((state) => state.calendar.data.beforeRecurringWorkouts[endpointFormattedDate]);
  const afterRecurringWorkouts = useSelector((state) => state.calendar.data.afterRecurringWorkouts[endpointFormattedDate]);
  const thisDayKey = programType === 'free-form-program'
    ? effectiveSelectedProgramDayNumber
    : endpointFormattedDate;
  const isThisDayHorizontallyExpanded = useSelector(
    (state) => String(state.calendar.data.weekViewExpandedDay) === String(thisDayKey),
  );
  const swapDropdownToggleEnabled = useSelector((state) => state.calendar.data.swapDropdownToggleEnabled);
  /** A non-empty selectedReduxAthlete is the athlete-level calendar signal - the reducer
   * clears it whenever a calendar or program becomes the selection, and vice versa. */
  const isAthleteLevelCalendar = useSelector(
    (state) => !!Object.keys(state.calendar.data.selectedReduxAthlete || {}).length,
  );
  const isActiveExercise = useSelector(
    (state) => state.calendar.data.activeExerciseId === content.assignedId,
  );
  const exerciseIsDeletedFromDatabase = content?.type === 'tag' ? content?.tag?.isDeleted : content?.exercise?.isDeleted;
  const [exerciseTextNameWidth, setExerciseTextNameWidth] = useState(null);

  const formatDate = () => `${moment(effectiveDate).format('YYYY-MM-DD')}`;

  const handleRemovePresaveItemFromRedux = () => {
    if (programType === 'free-form-program') {
      dispatch(removePresaveProgramItemFromRedux(effectiveSelectedProgramDayNumber, index, content.assignedId));
    } else {
      dispatch(removePresaveItemFromRedux(formatDate(), index, content.assignedId));
    }
  };

  // Keyboard shortcuts for the focused exercise: Ctrl/Cmd+D to delete, Ctrl/Cmd+I to open Additional Information
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!(e.ctrlKey || e.metaKey)) return;
      if (!isActiveExercise) return;
      const key = e.key.toLowerCase();

      if (key === 'd') {
        e.preventDefault();

        if (content.preSave) {
          handleRemovePresaveItemFromRedux();
        } else {
          const isParentCalendarItem = content.isInherited;
          dispatch(setActiveModal('confirmDeleteModal', {
            assignedId: content.assignedId,
            itemIndex: index,
            isRecurring,
            isParentCalendarItem,
            ...(programType === 'free-form-program' && { dayNumber: effectiveSelectedProgramDayNumber }),
            ...((isWeekView || onPopoverClose) && { date: effectiveDate }),
          }));
        }
        return;
      }

      if (key === 'i') {
        // Open the combined info/description modal for any type that supports either field.
        if (getExerciseInfoCategory(content) === 'none') return;
        e.preventDefault();
        dispatch(setActiveModal('addInfoOrDescriptionModal', {
          ...content,
          itemIndex: index,
          effectiveDate,
          dayNumber,
          isRecurring,
        }));
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isActiveExercise, content, index, isRecurring, programType, effectiveSelectedProgramDayNumber, isWeekView, effectiveDate, dayNumber]);

  let doesGroupingLetterAboveItemMatchContent;
  let doesGroupingLetterBelowItemMatchContent;

  if (isRecurring) {
    if (isRecurring === 'before') {
      const indexInBefore = beforeRecurringWorkouts?.findIndex((w) => w.assignedId === content.assignedId);

      doesGroupingLetterAboveItemMatchContent = !!content.groupingLetter
        && indexInBefore > 0
        && content.groupingLetter === beforeRecurringWorkouts?.[indexInBefore - 1]?.groupingLetter;

      doesGroupingLetterBelowItemMatchContent = !!content.groupingLetter
        && indexInBefore !== -1
        && content.groupingLetter === beforeRecurringWorkouts?.[indexInBefore + 1]?.groupingLetter;
    }
    if (isRecurring === 'after' && !isAthleteAddedItem) {
      const indexInAfter = afterRecurringWorkouts?.findIndex((w) => w.assignedId === content.assignedId);

      doesGroupingLetterAboveItemMatchContent = !!content.groupingLetter
        && indexInAfter > 0
        && content.groupingLetter === afterRecurringWorkouts?.[indexInAfter - 1]?.groupingLetter;

      doesGroupingLetterBelowItemMatchContent = !!content.groupingLetter
        && indexInAfter !== -1
        && content.groupingLetter === afterRecurringWorkouts?.[indexInAfter + 1]?.groupingLetter;
    }
    if (isRecurring === 'after' && isAthleteAddedItem) {
      const indexInAfter = athleteAddedItems?.findIndex((w) => w.assignedId === content.assignedId);

      doesGroupingLetterAboveItemMatchContent = !!content.groupingLetter
        && indexInAfter > 0
        && content.groupingLetter === athleteAddedItems?.[indexInAfter - 1]?.groupingLetter;

      doesGroupingLetterBelowItemMatchContent = !!content.groupingLetter
        && indexInAfter !== -1
        && content.groupingLetter === athleteAddedItems?.[indexInAfter + 1]?.groupingLetter;
    }
  } else {
    doesGroupingLetterAboveItemMatchContent = !!content.groupingLetter
    && content.groupingLetter === calendarItems[index - 1]?.groupingLetter;

    doesGroupingLetterBelowItemMatchContent = !!content.groupingLetter
    && content.groupingLetter === calendarItems[index + 1]?.groupingLetter;
  }

  /** this is the selected option in the select dropdown picker for the name of the exercise
   * we need to pull it out of the picker and put it on this level so we can pass it to the tables
   */
  const [selectedOption, setSelectedOption] = useState(null);
  /** phones open a full-screen swap picker instead of the react-select
   * dropdown, which renders off-screen on mobile */
  const [swapOverlayOpen, setSwapOverlayOpen] = useState(false);

  /** The kebab dropdown's "Swap" sets swapDropdownToggleEnabled to this item's
   * assignedId. On phones we consume it here to open the full-screen picker
   * (and clear the flag). Desktop has its own effect below, next to
   * showInlineSwap, which opens the react-select dropdown instead. */
  useEffect(() => {
    if (isMobile && swapDropdownToggleEnabled === content?.assignedId) {
      setSwapOverlayOpen(true);
      dispatch(setSwapDropdownToggleEnabled(false));
    }
  }, [dispatch, swapDropdownToggleEnabled, isMobile, content?.assignedId]);

  const typeDoesNotExpand = () => false;

  const typeDoesNotHaveTable = () => {
    if (content.type === 'warm_up' || content.type === 'W' || content.type === 'health' || content.type === 'H' || content.type === 'note' || content.type === 'N' || content.type === 'cooldown' || content.type === 'CD') {
      return true;
    }
    return false;
  };

  const typeHasSwap = () => {
    if (content.type === 'session_break' || content.type === 'rest' || content.type === 'video' || content.type === 'P' || content?.exercise?.type === 'P') {
      return false;
    }
    return true;
  };

  const typeHasIndividualScrollContainer = () => {
    if (content?.type === 'L' || content?.type === 'C' || content?.type === 'T' || content?.type === 'R') {
      return true;
    }
    return false;
  };

  /** Whether this item renders one of the transposed tables — mirroring the
   * flag-gated branches below, which key on `content.exercise.type` once saved
   * and on `content.type` while pre-save. Only these cycle Tab; the legacy
   * tables keep their own jump-to-picker handlers. */
  const rendersTransposedTable = () => {
    if (!flags?.transposedEditTable) return false;
    if (content?.preSave) {
      return content?.type === 'L' || content?.type === 'R'
        || content?.type === 'C' || content?.type === 'T';
    }
    return content?.exercise?.type === 'L' || content?.exercise?.type === 'R'
      || content?.exercise?.type === 'C' || content?.type === 'tag';
  };

  /** Tab wraps back to the item's entry field instead of escaping to whatever
   * is next in the document. Gated on the item being open: a collapsed row's
   * only focusable is its checkbox, and cycling that to itself would strand
   * the coach on it. Only the active exercise cycles — with two items open,
   * every item running its own cycle would fight over where Tab goes. */
  useTabCyclesWithinItem(
    itemRowRef,
    rendersTransposedTable() && (isExpanded || content?.preSave === true),
    isActiveExercise,
  );

  /** activeExerciseId is otherwise written only by a mouse click, so a coach
   * who tabs into a different item would be pulled back to the last one they
   * clicked. Focus entering this row makes it the active exercise. */
  useEffect(() => {
    const row = itemRowRef.current;
    if (!row) return undefined;

    const onFocusIn = () => {
      if (isActiveExercise) return;
      /** Same exclusions as the click writer below: an athlete-added or
       * parent-calendar item can't be edited, so it must not become the target
       * of the per-item shortcuts. */
      if (isAthleteAddedItem || readOnlyInheritedRecurringItem) return;
      dispatch(setActiveExerciseId(content.assignedId));
    };

    row.addEventListener('focusin', onFocusIn);
    return () => {
      row.removeEventListener('focusin', onFocusIn);
    };
  }, [
    content.assignedId,
    dispatch,
    isActiveExercise,
    isAthleteAddedItem,
    readOnlyInheritedRecurringItem,
  ]);

  const completionOnlySetting = () => {
    /** if the item is not a preSave item, meaning it is a saved item
     * getting returned from the update endpoint or from the get clalendar items
     * endpoint then we need to check if the original exercise is a circuit
     * and then check if that original exercise is of type 'C' for completion only
     * the other types should return completionOnly on the content
     */
    if (!content.preSave) {
      if (content?.exercise?.type === 'C' || content?.exercise?.type === 'circuit' || content.exercise?.inputType === 'C') {
        return true;
      }
      return content?.completionOnly;
    }
    /** if it IS a presaved item then we can grab these properties off the content */
    if (content.type === 'L') {
      return !!content.defaultOptions?.liftComp;
    }
    if (content.type === 'R') {
      if (content.inputType === 'C' || !!content.defaultOptions?.cardioComp) {
        return true;
      }
    }
    if (content.type === 'C') {
      return true;
    }
    return false;
  };

  const coachCompletionSetting = () => {
    if (!content.preSave) return !!content?.coachCompletion;
    if (content.type === 'L') {
      return !!content.defaultOptions?.liftCoachComp;
    }
    if (content.type === 'R') {
      return !!content.defaultOptions?.cardioCoach;
    }
    if (content.type === 'C') {
      return !!content.defaultOptions?.circuitCoach;
    }
    return false;
  };

  const getInitialStateForDisablePrUpdate = () => {
    if (content.type === 'lift' || content.type === 'L') {
      if (content.preSave ? (content?.track === 0) : !!content?.maxTrackingDisabled) {
        return true;
      }
      return false;
    }
    return false;
  };

  /** The eight option values as `content` (the server's copy) has them, keyed
   * by EXERCISE_OPTIONS id. Disable PR is undefined outside lifts and tags,
   * where content carries nothing to sync it from. */
  const getServerOptionValues = () => {
    const { preSave } = content;
    const defaultOptions = content?.defaultOptions || {};
    const tracksPrs = content.type === 'lift' || content.type === 'L' || content.type === 'T' || content.type === 'tag';
    return {
      coachCompletion: coachCompletionSetting(),
      completionOnly: completionOnlySetting(),
      isLeftAndRight: preSave ? !!defaultOptions?.eachSide : !!content?.eachSide,
      trackVolumeLoad: preSave ? !!defaultOptions?.trackVolLoad : !!content?.trackVolumeLoad,
      trackRepCount: preSave ? !!defaultOptions?.trackRepCount : !!content?.trackRepCount,
      forcePrUpdate: preSave ? !!defaultOptions?.forceMaxUpdate : !!content?.forceMaxUpdate,
      isBodyweight: preSave ? !!defaultOptions?.liftRepsOnly : !!content?.repsOnly,
      disablePrUpdate: tracksPrs
        ? (preSave ? content?.track === 0 : !!content?.maxTrackingDisabled)
        : undefined,
    };
  };
  /** The server values the re-sync effect last applied, so it can tell which
   * options a new `content` actually changed. See that effect. */
  const lastServerOptionsRef = useRef(null);

  const [windowWidth, setWindowWidth] = useState(0);
  const [coachCompletion, setCoachCompletion] = useState(coachCompletionSetting());
  const [completionOnly, setCompletionOnly] = useState(completionOnlySetting());
  const [trackVolumeLoad, setTrackVolumeLoad] = useState(
    content.preSave ? !!content.defaultOptions?.trackVolLoad : !!content?.trackVolumeLoad,
  );
  const [isLeftAndRight, setIsLeftAndRight] = useState(
    content.preSave ? !!content.defaultOptions?.eachSide : !!content?.eachSide,
  );
  const [trackRepCount, setTrackRepCount] = useState(
    content.preSave ? !!content.defaultOptions?.trackRepCount : !!content?.trackRepCount,
  );
  const [forcePrUpdate, setForcePrUpdate] = useState(content.preSave ? !!content.defaultOptions?.forceMaxUpdate : !!content?.forceMaxUpdate);
  const [disablePrUpdate, setDisablePrUpdate] = useState(getInitialStateForDisablePrUpdate());
  /** Owned here rather than in the tables so the three-dot menu - which renders
   * a level above them - can show and drive it alongside the other options.
   * Each table reconciles its own row model from this value. */
  const [isBodyweight, setIsBodyweight] = useState(
    content.preSave ? !!content.defaultOptions?.liftRepsOnly : !!content?.repsOnly,
  );
  const [assignedPace, setAssignedPace] = useState(
    content.preSave ? (content.defaultOptions?.pacing || '') : (content?.pacing || ''),
  );

  // Callback to save dropdown state to Redux
  const saveDropdownStateToRedux = useCallback((overrides = {}) => {
    /** Pre-save only: the backup is what a pre-save table restores from on
     * remount. A saved item has nothing to restore, and writing one anyway
     * changed preSaveBackup, which re-ran the re-sync effect below and reset
     * the option the coach had just toggled back to the not-yet-updated
     * content - the option (or pill) looked like it couldn't be clicked. */
    if (!content.preSave) return;
    const dropdownState = {
      coachCompletion,
      completionOnly,
      isLeftAndRight,
      trackVolumeLoad,
      trackRepCount,
      forcePrUpdate,
      disablePrUpdate,
      isBodyweight,
      ...overrides, // Override stale closure values with fresh ones
    };
    dispatch(setPreSaveTableLocalState(content.assignedId, dropdownState));
  }, [
    coachCompletion,
    completionOnly,
    isLeftAndRight,
    trackVolumeLoad,
    trackRepCount,
    forcePrUpdate,
    disablePrUpdate,
    isBodyweight,
    content.assignedId,
    content.preSave,
    dispatch,
  ]);
  const nonSwappedItemFromParentCalendar = isNonSwappedParentItem(content, isAthleteLevelCalendar);

  const [iconOb, setIconOb] = useState({
    coachCompletionToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Coach completion',
      icon: 'coach-completion',
      enabled: false,
    },
    completionOnlyToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Completion only',
      icon: 'completion-circle',
      enabled: false,
    },
    trackVolumeLoadToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Track volume load',
      icon: 'pr-tracking',
      enabled: false,
    },
    eachSideToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Each side',
      icon: 'trashcan',
      enabled: false,
    },
    trackRepCountToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Track rep count',
      icon: 'send',
      enabled: false,
    },
    forcePrUpdateToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Force PR update',
      icon: 'force-pr-update',
      enabled: false,
    },
    disablePrUpdateToggle: {
      id: generateUniqueId()?.toString(),
      label: 'PR update disabled',
      icon: 'force-pr-update',
      enabled: false,
      extra: <RedDashThrough />,
    },
    additionalInfoToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Additional Information Added',
      icon: 'note2',
      enabled: !!localAdditionalInfo || !!content.additionalInfo,
    },
    swapDropdownToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Swap',
      icon: null,
      enabled: swapDropdownToggleEnabled === content?.assignedId,
    },
    /** Required, not decorative: useExerciseOptionToggles indexes this object
     * by `iconObKey` unguarded and throws on a missing entry. `icon: null`
     * keeps it out of the inline icon strip, same as swapDropdownToggle. */
    bodyweightToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Bodyweight',
      icon: null,
      enabled: false,
    },
  });

  /** The single source of toggle behavior for this item's options. Shared by
   * the three-dot menu and the tables' Options dropdown / pills so the two
   * surfaces can't diverge. Setters are grouped once (useState setters are
   * stable) while values are rebuilt each render, which is what keeps the
   * toggle closures reading current state. */
  const exerciseOptionSetters = useMemo(() => ({
    coachCompletion: setCoachCompletion,
    completionOnly: setCompletionOnly,
    isLeftAndRight: setIsLeftAndRight,
    trackVolumeLoad: setTrackVolumeLoad,
    trackRepCount: setTrackRepCount,
    forcePrUpdate: setForcePrUpdate,
    disablePrUpdate: setDisablePrUpdate,
    isBodyweight: setIsBodyweight,
  }), []);

  const exerciseOptions = useExerciseOptionToggles({
    content,
    contentType: resolveExerciseContentType(content),
    defaultExOptions: getDefaultExerciseOptions(content),
    iconOb,
    setIconOb,
    values: {
      coachCompletion,
      completionOnly,
      isLeftAndRight,
      trackVolumeLoad,
      trackRepCount,
      forcePrUpdate,
      disablePrUpdate,
      isBodyweight,
    },
    setters: exerciseOptionSetters,
    onOptionsChange: saveDropdownStateToRedux,
    isItemLocked,
  });
  const { colors } = useTheme();

  const getItemsUnderSessionBreak = (currentItem) => {
    const items = beforeOrAfter === 'before' ? beforeRecurringWorkouts : beforeOrAfter === 'after' ? afterRecurringWorkouts : calendarItems;
    if (!currentItem || currentItem.type !== 'session_break') return {};

    const currentIndex = items.findIndex(
      (c) => c?.assignedId === currentItem?.assignedId,
    );
    if (currentIndex === -1) return {};

    const result = {};
    let reachedNextBreak = false;

    items.map((calItem, i) => {
      if (i <= currentIndex || reachedNextBreak) return;
      if (calItem.type === 'session_break') {
        reachedNextBreak = true;
        return;
      }
      result[calItem.assignedId] = calItem;
    });

    return result;
  };

  const NumberOfItemsUnderSessionBreak = Object?.values(getItemsUnderSessionBreak(content))?.length ? Object?.values(getItemsUnderSessionBreak(content))?.length : 0;

  const handleCheckboxChange = () => {
    const currentSelectedItems = store.getState().calendar.data.selectedItems;

    if (content?.type === 'session_break') {
      const itemsUnder = getItemsUnderSessionBreak(content);
      const allIds = [content.assignedId, ...Object.keys(itemsUnder)];

      /** Check if the session break itself is selected */
      const isSelected = allIds.some((id) => currentSelectedItems[id]);

      if (isSelected) {
        /** Deselect session break and all items under it — single dispatch */
        const remaining = { ...currentSelectedItems };
        allIds.forEach((id) => { delete remaining[id]; });
        dispatch(setSelectedItems(remaining));
      } else {
        /** Select session break and all items under it — single dispatch */
        const newItems = { ...currentSelectedItems, [content.assignedId]: content };
        Object.values(itemsUnder).forEach((underItem) => {
          newItems[underItem.assignedId] = underItem;
        });
        dispatch(setSelectedItems(newItems));
      }
    } else {
    /** Regular item toggle */
      // eslint-disable-next-line no-lonely-if
      if (selectedItem) {
        dispatch(removeSelectedItem(content));
      } else {
        dispatch(setSelectedItem(content));
      }
    }
  };

  const inLineActionsObject = {
    expandOrCollapse: {
      id: generateUniqueId()?.toString(),
      label: isExpanded ? 'Collapse' : 'Expand',
      icon: isExpanded ? 'collapse' : 'expand2',
      onClick: ((!content.preSave && !typeDoesNotExpand()) && setIsExpanded),
      enabled: !onPopoverClose && !typeDoesNotExpand() && !content.preSave,
    },
    superSet: {
      id: generateUniqueId()?.toString(),
      label: 'Superset',
      icon: 'superset',
      onClick: () => {},
      enabled: content?.type !== 'session_break' && content?.type !== 'questionnaire',
    },
    moveUp: {
      id: generateUniqueId()?.toString(),
      label: 'Move up',
      icon: 'alt-up-arrow',
      onClick: () => {
        if (!isRecurring && index !== 0 && calendarItems?.length !== 1) {
          const originalItems = [...calendarItems];
          const newItems = Array.from(calendarItems);
          const [removed] = newItems.splice(index, 1);
          newItems.splice(index - 1, 0, removed);
          const newOrderedAssignmentIds = [];
          newItems.forEach((calendarItem) => {
            if (typeof calendarItem.assignedId !== 'string') {
              newOrderedAssignmentIds.push(calendarItem.assignedId);
            }
          });

          if (programType === 'free-form-program') {
            const submissionObject = {
              dayNumber: effectiveSelectedProgramDayNumber,
              order: newOrderedAssignmentIds,
            };

            /** we need to set items here before checking length in case all items are pre save items
             * which would track newOrderAssignmentIds as 0 lenght
             */
            dispatch(setNonDateBasedProgramItems(newItems, effectiveSelectedProgramDayNumber));
            if (newOrderedAssignmentIds?.length) {
              dispatch(updateWorkoutItemsOrder(currentUser.accountCode, submissionObject, originalItems));
            }
          } else {
            const submissionObject = {
              date: moment(effectiveDate).format('YYYY-MM-DD'),
              order: newOrderedAssignmentIds,
              assignedIdsBeingMoved: [removed.assignedId],
              movedToIndex: newOrderedAssignmentIds.indexOf(removed.assignedId),
            };

            /** we need to set items here before checking length in case all items are pre save items
             * which would track newOrderAssignmentIds as 0 length.
             */
            dispatch(setCalendarItems(newItems, moment(effectiveDate).format('YYYY-MM-DD')));
            if (newOrderedAssignmentIds?.length) {
              dispatch(updateCalendarItemsOrder(currentUser.accountCode, submissionObject, originalItems));
            }
          }
        }
      },
      enabled: !onPopoverClose && !isRecurring && index !== 0 && calendarItems?.length !== 1,
    },
    moveDown: {
      id: generateUniqueId()?.toString(),
      label: 'Move down',
      icon: 'alt-down-arrow',
      onClick: () => {
        if (!isRecurring && calendarItems?.length > 1 && index !== calendarItems?.length - 1) {
          const originalItems = [...calendarItems];
          const newItems = Array.from(calendarItems);
          const [removed] = newItems.splice(index, 1);
          newItems.splice(index + 1, 0, removed);

          const newOrderedAssignmentIds = [];
          newItems.forEach((calendarItem) => {
            if (typeof calendarItem.assignedId !== 'string') {
              newOrderedAssignmentIds.push(calendarItem.assignedId);
            }
          });

          if (programType === 'free-form-program') {
            const submissionObject = {
              dayNumber: effectiveSelectedProgramDayNumber,
              order: newOrderedAssignmentIds,
            };

            /** we need to set items here before checking length in case all items are pre save items
             * which would track newOrderAssignmentIds as 0 lenght
             */
            dispatch(setNonDateBasedProgramItems(newItems, effectiveSelectedProgramDayNumber));
            if (newOrderedAssignmentIds?.length) {
              dispatch(updateWorkoutItemsOrder(currentUser.accountCode, submissionObject, originalItems));
            }
          } else {
            const submissionObject = {
              date: moment(effectiveDate).format('YYYY-MM-DD'),
              order: newOrderedAssignmentIds,
              assignedIdsBeingMoved: [removed.assignedId],
              movedToIndex: newOrderedAssignmentIds.indexOf(removed.assignedId),
            };

            /** set items or UX order here */
            dispatch(setCalendarItems(newItems, moment(effectiveDate).format('YYYY-MM-DD')));
            if (newOrderedAssignmentIds?.length) {
              dispatch(updateCalendarItemsOrder(currentUser.accountCode, submissionObject, originalItems));
            }
          }
        }
      },
      enabled: !onPopoverClose && !isRecurring && calendarItems?.length > 1
      && index !== calendarItems?.length - 1,
    },
    delete: {
      id: generateUniqueId()?.toString(),
      label: 'Delete',
      icon: 'delete',
      onClick: () => {
        if (content.preSave) {
          handleRemovePresaveItemFromRedux();
        } else {
          // Show confirmation modal instead of direct deletion
          const isParentCalendarItem = content.isInherited;
          dispatch(setActiveModal('confirmDeleteModal', {
            assignedId: content.assignedId,
            itemIndex: index,
            isRecurring,
            isParentCalendarItem,
            ...(programType === 'free-form-program' && { dayNumber }),
            ...((isWeekView || onPopoverClose) && { date: effectiveDate }),
          }));
        }
      },
      enabled: true,
    },
  };

  const isChecked = !!selectedItem;

  useEffect(() => {
    /** GUARD: Don't reset a pre-save item that has a backup - user has made
     * changes. Scoped to pre-save because saved items also get a backup (every
     * option toggle writes one) that nothing ever clears; guarding on it alone
     * would stop saved items re-syncing from server data, e.g. leaving
     * Bodyweight stuck on after an undo that doesn't remount the row. */
    if (content.preSave && preSaveBackup) {
      return; // Let PreSaveTable's restoration useEffect handle it
    }

    // Only reset from defaultOptions if no backup exists
    const newIconOb = { ...iconOb };
    const next = getServerOptionValues();
    const previous = lastServerOptionsRef.current;

    /** Only options whose server value moved since the last content are copied
     * onto local state. An option save's response lands while the coach may
     * already have toggled another option; it still carries that option's old
     * value, and resetting every option from it unchecked the newer toggle -
     * whose now-reverted value the debounced save then sent. A refetch (e.g.
     * after undo) does change the values, so it still propagates server truth.
     * `previous` is null on mount, where everything syncs. */
    Object.keys(next).forEach((optionId) => {
      /** undefined = not applicable to this item type (Disable PR outside
       * lifts and tags), so the local value is left as it is. */
      if (next[optionId] === undefined) return;
      if (previous && previous[optionId] === next[optionId]) return;
      const option = EXERCISE_OPTIONS.find((o) => o.id === optionId);
      newIconOb[option.iconObKey].enabled = next[optionId];
      exerciseOptionSetters[optionId](next[optionId]);
    });
    lastServerOptionsRef.current = next;
    setIconOb(newIconOb);
    /** if conent changes we need to reselt the select dropdown
     * so that the name of the exercise reflects the updated content
     * this is important if a call fails and you have an out of sync exericse
     * name relfected in the exercise picker
     */
    setSelectedOption(null);
  }, [content, preSaveBackup]);

  useEffect(() => {
    const matchedInfo = preSaveAddInfo?.find((info) => info.id === content?.id);

    if (matchedInfo) {
      setLocalAdditionalInfo(matchedInfo.content);
    }
  }, [preSaveAddInfo, content?.id]);

  /** watch for updates in additional info and set the pill icon to enabled if user
   adds additional info
   */
  useEffect(() => {
    const newIconOb = { ...iconOb };
    newIconOb.additionalInfoToggle.enabled = !!localAdditionalInfo || content.additionalInfo;
    setIconOb(newIconOb);
  }, [localAdditionalInfo, content]);

  useEffect(() => {
    const matchedInfo = preSaveDescription?.find((desc) => desc.id === content?.id);

    if (matchedInfo) {
      setLocalDescription(matchedInfo.content);
    }
  }, [preSaveDescription, content?.id]);

  /** Update window width on resize */
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (isThisItemSupersetPickerOpen) {
        dispatch(removeSuperSetPickerOpenById(content.assignedId));
      }
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [isThisItemSupersetPickerOpen]);

  const iconColorWriter = (icon) => {
    if (icon === 'question-mark-circle') {
      return '#9B59B6';
    }
    if (icon === 'science') {
      return '#9B59B6';
    }
    if (icon === 'warmup') {
      return '#E74C3C';
    }
    if (icon === 'lift') {
      return '#6C7A89';
    }
    if (icon === 'cardio') {
      return '#59ABE3';
    }
    if (icon === 'circuit') {
      return '#F89406';
    }
    if (icon === 'cooldown') {
      return '#1787FB';
    }
    if (icon === 'health' || icon === 'heart') {
      return '#E74C3C';
    }
    if (icon === 'note') {
      return '#F9BF3B';
    }
    if (icon === 'chart') {
      return '#FF00BF';
    }
    if (icon === 'tag2' || icon === 'tag') {
      return '#FF4500';
    }
    if (icon === 'page-break' || icon === 'break') {
      return 'white';
    }
    if (icon === 'rest' || icon === 'clock') {
      return '#6C7A89';
    }
    if (icon === 'video-add' || icon === 'video') {
      return '#6C7A89';
    }
    if (icon === 'plus') {
      return '#9E9E9E';
    }
    return '';
  };

  const iconBackgroundColor = ({ line }) => {
    const icon = content.groupingLetter ? 'groupingLetter' : content.icon;
    if (icon === 'question-mark-circle') {
      return 'rgba(155, 89, 182, 0.2)';
    }
    if (icon === 'science') {
      return 'rgba(155, 89, 182, 0.2)';
    }
    if (icon === 'warmup') {
      return 'rgba(231, 76, 60, 0.2)';
    }
    if (icon === 'lift') {
      return 'rgba(108, 122, 137, 0.2)';
    }
    if (icon === 'cardio') {
      return 'rgba(89, 171, 227, 0.2)';
    }
    if (icon === 'circuit') {
      return 'rgba(248, 148, 6, 0.2)';
    }
    if (icon === 'cooldown') {
      return 'rgba(23, 135, 251, 0.2)';
    }
    if (icon === 'health' || icon === 'heart') {
      return 'rgba(231, 76, 60, 0.2)';
    }
    if (icon === 'note') {
      return 'rgba(249, 191, 59, 0.2)';
    }
    if (icon === 'chart') {
      return 'rgba(255, 0, 191, 0.2)';
    }
    if (icon === 'tag2' || icon === 'tag') {
      return 'rgba(255, 69, 0, 0.2)';
    }
    if (icon === 'page-break' || icon === 'break') {
      if (line) {
        return 'rgba(108, 122, 137, 0.2)';
      }
      return '#34495e';
    }
    if (icon === 'rest' || icon === 'clock') {
      return 'rgba(108, 122, 137, 0.2)';
    }
    if (icon === 'video-add' || icon === 'video') {
      return 'rgba(108, 122, 137, 0.2)';
    }
    if (icon === 'plus') {
      return 'white';
    }
    if (icon === 'groupingLetter') {
      return hexToRgba(normalizeSupersetColor(content?.groupingColorCode), 0.2);
    }
    return '';
  };

  const accessoryItem = (icon) => {
    if (icon === 'rest' || icon === 'clock') {
      return true;
    }
    if (icon === 'video-add' || icon === 'video') {
      return true;
    }
    if (icon === 'plus') {
      return true;
    }
    return false;
  };

  const inLineActionsIconDisplayer = (iconObArg) => {
    const iconKeys = Object.keys(iconObArg);
    const icoSet = iconKeys.map((key) => {
      const iconObject = iconObArg[key];
      if (iconObject.enabled && iconObject.icon) {
        return (
          <React.Fragment key={generateUniqueId()}>
            {iconObject.label === 'Superset' ? (
              <Dropdown
                trigger={['click']}
                overlay={(
                  <MenuWrapper onClick={(e) => e.stopPropagation()}>
                    <Menu
                      className='custom-rc-menu superset-picker-menu'
                      style={{
                        width: 'auto',
                        minHeight: 50,
                        maxHeight: 300,
                        overflowY: 'auto',
                        border: `1px solid ${colors.borderLight}`,
                        background: colors.surface,
                      }}
                    >
                      <MenuItem
                        key='superset-picker'
                        style={{ padding: 0, margin: 0 }}
                      >
                        <SuperSetPickerPopup content={content} left={0} top={0} isRecurring={isRecurring} setSuperSetDropdownVisible={() => {}} inLineAction effectiveDate={effectiveDate} dayNumber={dayNumber} />
                      </MenuItem>
                    </Menu>
                  </MenuWrapper>
                )}
                visible={isThisItemSupersetPickerOpen}
                onVisibleChange={(visible) => {
                  /** rc-dropdown opens itself on click, independently of the
                   * onClick below, so the lock has to be enforced here too —
                   * the overlay stops the mouse but not a programmatic open. */
                  if (isItemLocked) return;
                  if (visible) {
                    dispatch(setSuperSetPickerOpenById(content.assignedId));
                  } else {
                    dispatch(removeSuperSetPickerOpenById(content.assignedId));
                  }
                }}
              >
                <InLineActionsIconContainer data-tooltip-id={iconObject.id} onClick={isItemLocked ? undefined : iconObject.onClick} isDeleteIcon={iconObject.icon === 'delete'}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={iconObject?.icon === 'superset' ? 30 : 15}
                    icon={iconObject.icon}
                    className='inLineActionsIcons'
                  />
                  {iconObject.extra}
                </InLineActionsIconContainer>
              </Dropdown>
            ) : (
              /** Kept rendered rather than unmounted while locked, so the row
               * doesn't change shape mid-save and force a re-measure. The
               * overlay blocks the mouse; dropping onClick covers the rest. */
              <InLineActionsIconContainer data-tooltip-id={iconObject.id} onClick={isItemLocked ? undefined : iconObject.onClick} isDeleteIcon={iconObject.icon === 'delete'}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={15}
                  icon={iconObject.icon}
                  className='inLineActionsIcons'
                />
                {iconObject.extra}
              </InLineActionsIconContainer>
            )}
            <ReactTooltip
              id={iconObject.id}
              place='top'
              content={`${iconObject.label}`}
              style={{
                backgroundColor: 'rgba(68, 68, 68, 1)',
                color: colors.white,
                fontFamily: 'Nunito Sans',
                fontSize: '13px',
                zIndex: 1000,
              }}
            />
          </React.Fragment>
        );
      }
      return null;
    });
    return icoSet;
  };

  const paceDisplaySection = () => {
    // Only show pace for SAQC items (type 'R') that have an assigned pace
    if ((content.type === 'R' || content?.exercise?.type === 'R') && assignedPace) {
      return (
        <div style={{ marginBottom: '8px' }}>
          <Text fontSize='12px' color={colors.text} style={{ fontFamily: 'Nunito Sans' }}>
            Pace:
            {' '}
            {formatPaceLabel(assignedPace)}
          </Text>
        </div>
      );
    }
    return null;
  };

  const openInfoModal = (e) => {
    e.stopPropagation();
    flushDebounceForTable(content.assignedId);
    dispatch(setActiveModal('addInfoOrDescriptionModal', {
      ...content, itemIndex: index, effectiveDate, dayNumber, isRecurring,
    }));
  };

  const infoEditSection = (paramContent) => {
    const infoCategory = getExerciseInfoCategory(paramContent);
    const isShimmering = isCalendarItemSavingOrUpdating && (activeModal !== 'addInfoOrDescriptionModal') && typeDoesNotHaveTable();

    if (infoCategory === 'additionalInfo') {
      const additionalInfo = localAdditionalInfo || paramContent?.additionalInfo || paramContent?.exercise?.additionalInfo;
      return (
        <TextInfoColumn>
          <DescriptionText>
            {isShimmering ? (
              <Shimmer>
                <ShimmerDescription />
              </Shimmer>
            ) : (
              <>
                {additionalInfo ? null : (
                  <AddDescriptionButton onClick={openInfoModal}>
                    {`+ Add Additional Info ${additionalInfoShortcutLabel}`}
                  </AddDescriptionButton>
                )}
                <span style={{ fontFamily: 'nunito sans' }}>
                  {localAdditionalInfo || decodeHtmlEntities(paramContent?.additionalInfo) || decodeHtmlEntities(paramContent.exercise?.additionalInfo)}
                  {additionalInfo ? (
                    <EditDescriptionButton onClick={openInfoModal}>
                      {`Edit ${additionalInfoShortcutLabel}`}
                    </EditDescriptionButton>
                  ) : null}
                </span>
              </>
            )}
          </DescriptionText>
        </TextInfoColumn>
      );
    }

    if (infoCategory === 'both') {
      // Combine additional info, circuit subtitle, and description into one display string (no field
      // labels). A saved circuit's subTitle already contains its description, so buildBothInfoText
      // avoids appending it twice — see that util for the full rationale.
      const combinedInfo = buildBothInfoText(paramContent, { localAdditionalInfo, localDescription });
      return (
        <TextInfoColumn>
          <DescriptionText style={{ flexDirection: 'column' }}>
            {isShimmering ? (
              <Shimmer>
                <ShimmerDescription />
              </Shimmer>
            ) : (
              <>
                {combinedInfo ? null : (
                  <AddDescriptionButton onClick={openInfoModal}>
                    {`+ Add Description Or Additional Info ${additionalInfoShortcutLabel}`}
                  </AddDescriptionButton>
                )}
                <span style={{ fontFamily: 'nunito sans', whiteSpace: 'pre-wrap' }}>
                  {combinedInfo}
                </span>
                {combinedInfo ? (
                  <EditDescriptionButton style={{ marginLeft: 0 }} onClick={openInfoModal}>
                    {`Edit Description Or Additional Info ${additionalInfoShortcutLabel}`}
                  </EditDescriptionButton>
                ) : null}
              </>
            )}
          </DescriptionText>
        </TextInfoColumn>
      );
    }

    // description only (warm_up / note / cooldown)
    return (
      <TextInfoColumn>
        <DescriptionText style={{ flexDirection: 'column' }}>
          {isShimmering ? (
            <Shimmer>
              <ShimmerDescription />
            </Shimmer>
          ) : (
            <>
              {localDescription || paramContent?.description ? null : (
                <AddDescriptionButton onClick={openInfoModal}>
                  {`+ Add Description ${additionalInfoShortcutLabel}`}
                </AddDescriptionButton>
              )}
              <span style={{ fontFamily: 'nunito sans', whiteSpace: 'pre-wrap' }}>
                {localDescription || decodeHtmlEntities(paramContent?.description)}
              </span>
              {(!paramContent?.description && !localDescription) ? null : (
                <EditDescriptionButton style={{ marginLeft: 0 }} onClick={openInfoModal}>
                  {`Edit ${additionalInfoShortcutLabel}`}
                </EditDescriptionButton>
              )}
            </>
          )}
        </DescriptionText>
      </TextInfoColumn>
    );
  };

  const typeResolver = () => {
    if (content?.type === 'session_break') {
      return 'session_break';
    }
    if (content?.type === 'rest') {
      return 'rest';
    }
    if (content?.preSave) {
      return content?.type;
    }
    return content?.exercise?.type;
  };

  const getName = () => {
    if (content.type === 'video' && !content.title) {
      return 'Video';
    }
    if (content.type === 'session_break' && (!content.title || content.title === 'Session')) {
      return 'Session Break';
    }
    if (content.type === 'rest') {
      if (content.restTime) {
        return `Rest Time (${content?.restTime} sec)`;
      }
      return 'Rest Time';
    }
    return content.title;
  };

  const [addExerciseToggleMenuOpen, setAddExerciseToggleMenuOpen] = useState(false);
  const [sessionBreakInputOpen, setSessionBreakInputOpen] = useState(false);
  const [sessionBreakInputValue, setSessionBreakInputValue] = useState(content?.title === 'Session' ? '' : content?.title);

  useLayoutEffect(() => {
    if (exercisePickerTextRef.current) {
      requestAnimationFrame(() => {
        setExerciseTextNameWidth(exercisePickerTextRef?.current?.offsetWidth);
      });
    }
  }, [addExerciseToggleMenuOpen, getName()]);

  /** Inline name-click swap. Shown whenever the item's detail/table is
   * visible - expanded, pre-save (table force-shown), or a non-expanding
   * type. Same condition on mobile and desktop; mobile routes the trigger to
   * the full-screen picker, desktop to the react-select dropdown.
   * Note: a pre-save item looks expanded (its table shows) but its isExpanded
   * prop is false, so gating on isExpanded alone would hide swap for it. */
  const showInlineSwap = (isExpanded || typeDoesNotExpand() || content.preSave)
    && !isRecurring && typeHasSwap();

  /** Desktop counterpart of the mobile swap-flag effect above. The swap
   * dropdown mounts only while open, so it can't listen for the kebab's "Swap"
   * itself - open it here once the inline swap is showing (Swap also expands
   * the item, which is what makes showInlineSwap true). */
  useEffect(() => {
    if (!isMobile && showInlineSwap && swapDropdownToggleEnabled === content?.assignedId) {
      setAddExerciseToggleMenuOpen(true);
      dispatch(setSwapDropdownToggleEnabled(false));
    }
  }, [dispatch, swapDropdownToggleEnabled, isMobile, showInlineSwap, content?.assignedId]);

  return (
    <Container
      isActive={isActiveExercise && !onPopoverClose}
      onClickCapture={() => {
        if (!addExerciseToggleMenuOpen && !isAthleteAddedItem && !readOnlyInheritedRecurringItem) {
          dispatch(setActiveExerciseId(content.assignedId));
        }
      }}
    >
      {/* Phones: full-screen swap picker. Rendered at the item root (not inside
          the expand-gated name block) so collapsing the item behind it can't
          unmount it. Mounts only while open. */}
      {isMobile && swapOverlayOpen && (
        <MobileAddExercisePicker
          mode='swap'
          isOpen
          onClose={() => setSwapOverlayOpen(false)}
          date={effectiveDate}
          dayNumber={effectiveSelectedProgramDayNumber}
          typeToFilter={content?.exercise?.type || content.type}
          onSwapSelect={setSelectedOption}
        />
      )}
      {isHovered && content.type !== 'session_break' && content.type !== 'questionnaire' && itemHoveringOverCurrentItem?.type !== 'session_break' && itemHoveringOverCurrentItem?.type !== 'questionnaire' ? (
        content.groupingLetter ? (
          <AbsoluteText>Add to Superset</AbsoluteText>
        ) : (
          <AbsoluteText>Drop to Create a Superset</AbsoluteText>
        )
      ) : null}
      <ItemRow
        ref={itemRowRef}
        data-exercise-item
        /** Read-only items never become active, so useTabCyclesWithinItem
         * needs this to leave Tab inside them alone. */
        data-read-only-item={(isAthleteAddedItem || readOnlyInheritedRecurringItem) || undefined}
        onClick={() => {
          if (isItemLocked) return;
          if (isWeekView && !isDayExpanded && onDayExpand) {
            // Clear all expanded items in other day columns first
            // dispatch(setExpandedItems({}));
            onDayExpand();
            if (!content.preSave && !typeDoesNotExpand()) {
              /** commenting this out for now if click on item and
               * we need to expand horizontally and vertically measure()
               * is having time getting correct size for notes, warm ups, cooldowns
               * etc. basically the text based tables
               */
              // setIsExpanded(true);
            }
          } else {
            !content.preSave && !typeDoesNotExpand() && setIsExpanded(true);
          }
        }}
        style={{ opacity: (isHovered && content.type !== 'session_break' && content.type !== 'questionnaire' && itemHoveringOverCurrentItem?.type !== 'session_break' && itemHoveringOverCurrentItem?.type !== 'questionnaire') ? 0.5 : 1 }}
        doesGroupingLetterAboveItemMatchContent={doesGroupingLetterAboveItemMatchContent}
        doesGroupingLetterBelowItemMatchContent={doesGroupingLetterBelowItemMatchContent}
        isWeekView={isWeekView}
      >
        {isItemLocked && (
        <ItemLockOverlay data-item-lock dim={isSwapLoading} aria-hidden='true' />
        )}
        <IconAndCheckBoxContainer
          checkboxVisible={((isSavingThisItem && typeDoesNotExpand() && !isChecked)) ? false : checkboxVisible}
          isChecked={isChecked}
          isWeekView={(isWeekView && !isThisDayHorizontallyExpanded) || isTvMode}
        >
          {(!isWeekView || isThisDayHorizontallyExpanded) && !isTvMode && !omitCheckbox && (
            <input
              className='checkbox-input'
              type='checkbox'
              name={content?.exercise?.name}
              checked={isChecked}
              /** The one natively focusable control on the row, so the overlay
               * alone wouldn't keep a keyboard user out of it. */
              disabled={isItemLocked}
              onClick={(event) => {
                event.stopPropagation();
                handleCheckboxChange();
              }}
            />
          )}
          <IconContainer ref={dragHandleTouchBridgeRef} isTvMode={isTvMode} background={accessoryItem(content.icon) && !content.groupingLetter ? colors.surface : iconBackgroundColor({ line: false })} borderColor={iconBackgroundColor({ line: false })} isMobileDragHandle={!!dragHandleProps} {...dragHandleProps}>
            {content.groupingLetter ? (
              <Text style={{ margin: 0 }} fontSize='12pt' color={normalizeSupersetColor(content.groupingColorCode)}>{content.groupingLetter}</Text>
            ) : (
              <IcomoonReact
                iconSet={iconSet}
                size={isTvMode ? 20 : 16}
                icon={content.icon === 'break' ? 'page-break' : content.icon}
                color={iconColorWriter(content.icon)}
              />
            )}
            {content.isInherited && !exerciseIsDeletedFromDatabase && (
              <>
                <ParentOrSwapIcon
                  data-tooltip-id={`parent-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                >
                  <ParentIconBorderBox>
                    <Text fontSize={10} style={{ marginTop: 3 }} color={colors.white}>
                      P
                    </Text>
                  </ParentIconBorderBox>
                </ParentOrSwapIcon>
                <ReactTooltip
                  id={`parent-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                  key={`parent-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                  place='top'
                  content={readOnlyInheritedRecurringItem ? 'This item is from a parent calendar and cannot be edited.' : 'From Parent Calendar'}
                  style={{
                    zIndex: 9999,
                    backgroundColor: 'rgba(68, 68, 68, 1)',
                    color: colors.white,
                    fontFamily: 'Nunito Sans',
                    fontSize: '13px',
                  }}
                />
              </>
            )}
            {content?.swap && !exerciseIsDeletedFromDatabase && (
              <>
                <ParentOrSwapIcon
                  data-tooltip-id={`swapped-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={10}
                    icon='swap'
                    color={colors.white}
                  />
                </ParentOrSwapIcon>
                <ReactTooltip
                  id={`swapped-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                  key={`swapped-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                  place='top'
                  content='Swapped Exercise'
                  style={{
                    zIndex: 9999,
                    backgroundColor: 'rgba(68, 68, 68, 1)',
                    color: colors.white,
                    fontFamily: 'Nunito Sans',
                    fontSize: '13px',
                  }}
                />
              </>
            )}
            {exerciseIsDeletedFromDatabase && (
            <>
              <DeletedItemIcon data-tooltip-id={`deletedItem-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={12}
                  icon='warning'
                />
              </DeletedItemIcon>
              <ReactTooltip
                id={`deletedItem-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                key={`deletedItem-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                place='top'
                positionStrategy='fixed'
                content={isAthleteAddedItem ? 'This item added by the athlete is no longer in your database. You can view records of this in workout results, but max/PR data will not be available.' : `This item ${content?.isInherited ? 'is inherited from a parent calendar and ' : ''}is no longer in your library. It will appear to athletes but data will be limited. We suggest you delete each occurrence or update future occurrences to swap all.`}
                style={{
                  zIndex: 9999,
                  backgroundColor: 'rgba(68, 68, 68, 1)',
                  color: colors.white,
                  fontFamily: 'Nunito Sans',
                  fontSize: '13px',
                  maxWidth: (isWeekView && !isThisDayHorizontallyExpanded) ? '175px' : '250px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                }}
              />
            </>
            )}
          </IconContainer>
        </IconAndCheckBoxContainer>
        <LineContainer isTvMode={isTvMode}>
          {(!isWeekView || isThisDayHorizontallyExpanded) && !omitCheckbox && (
          <AbsolutelyPositionedCheckBoxClickArea
            style={{ zIndex: 999 }}
            onClick={(event) => {
              event.stopPropagation();
              handleCheckboxChange();
            }}
          />
          )}
          {!onPopoverClose && (
            <Line
              isHovered={isHovered}
              isDragging={isDragging}
              color={
              content.groupingColorCode
                ? normalizeSupersetColor(content.groupingColorCode)
                : iconBackgroundColor({ line: true })
              }
              doesGroupingLetterAboveItemMatchContent={doesGroupingLetterAboveItemMatchContent}
              doesGroupingLetterBelowItemMatchContent={doesGroupingLetterBelowItemMatchContent}
              isWeekView={isWeekView && !isThisDayHorizontallyExpanded}
              isTvMode={isTvMode}
              omitCheckbox={omitCheckbox}
            />
          )}
          <ClickContainer
            isExpanded={isExpanded || content.preSave || typeDoesNotExpand()}
            isPreSave={content.preSave}
            ref={clickContainerRef}
            addPaddingBottom={content.type === 'session_break' && isExpanded}
            type={content.type}
          >
            <TextColumn ref={textWrapperRef} isPopover={!!onPopoverClose}>
              {/* Invisible measurement span for exercise picker text */}
              <span
                ref={exercisePickerTextRef}
                style={{
                  position: 'absolute',
                  visibility: 'hidden',
                  whiteSpace: 'nowrap',
                  font: 'inherit', // IMPORTANT: match font exactly
                }}
              >
                {getName()}
              </span>
              {/* eslint-disable-next-line no-nested-ternary */}
              {showInlineSwap ? (
                isMobile ? (
                  <NameTextAndDownArrowContainer
                    maxWidth={exerciseTextNameWidth}
                    /* Open on CLICK, not mouseDown: opening the full-screen
                     * overlay mid-tap makes the same tap's trailing mouseup/
                     * click land inside the overlay (on a row, since the name
                     * is mid-screen), which swallowed the first in-overlay tap
                     * (the "two taps to select" bug). onClick defers the
                     * overlay until the tap fully completes. stopPropagation
                     * keeps the tap from bubbling to ItemRow (toggle/collapse);
                     * the overlay lives at the item root so it survives. */
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!readOnlyInheritedRecurringItem && !isAthleteAddedItem) {
                        setSwapOverlayOpen(true);
                      }
                    }}
                  >
                    <NameText isTvMode={isTvMode} style={{ maxWidth: 'fit-content', cursor: (!readOnlyInheritedRecurringItem && !isAthleteAddedItem) ? 'pointer' : undefined }}>{getName()}</NameText>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={10}
                      icon='gs-arrow-down'
                      color='rgba(189, 189, 189, 1)'
                      style={{ minWidth: 10 }}
                    />
                  </NameTextAndDownArrowContainer>
                ) : (
                  <>
                    {/* Mounts only while open - one per item card otherwise,
                        each holding the account's full exercise list. */}
                    {addExerciseToggleMenuOpen && (
                    <SelectDropdownExercisePicker
                      iconOb={iconOb}
                      setIconOb={setIconOb}
                      textWrapperRef={textWrapperRef}
                      defaultValue={{
                        name: content.title,
                        id: content.exerciseId,
                        icon: null,
                      }}
                      fullWidthInput
                      typeToFilter={content?.exercise?.type || content.type}
                      isChecked={isChecked}
                      selectedOption={selectedOption}
                      setSelectedOption={setSelectedOption}
                      addExerciseToggleMenuOpen={addExerciseToggleMenuOpen}
                      setAddExerciseToggleMenuOpen={setAddExerciseToggleMenuOpen}
                      showSelectOnStart={false}
                      assignedId={content?.assignedId}
                      disableMenuScrollBlock={!!onPopoverClose}
                      isDisabled={isItemLocked}
                    />
                    )}
                    {!addExerciseToggleMenuOpen && (
                    <NameTextAndDownArrowContainer
                      maxWidth={exerciseTextNameWidth}
                      onMouseDown={() => {
                        if (onPopoverClose) {
                          /** In month-view popover, defer the state flip
                           * past the current event loop tick. Flipping
                           * during mousedown causes
                           * SelectDropdownExercisePicker's
                           * `handleClickOutside` (registered on
                           * document mousedown) to fire after the
                           * Select mounts, see the original click
                           * target as detached/outside, and immediately
                           * close the menu we just opened. Week/day
                           * view doesn't hit this race because the
                           * picker isn't isExpanded-by-default there. */
                          setTimeout(() => setAddExerciseToggleMenuOpen(true), 0);
                          return;
                        }
                        setAddExerciseToggleMenuOpen(!addExerciseToggleMenuOpen);
                      }}
                    >
                      <NameText isTvMode={isTvMode} style={{ maxWidth: 'fit-content', cursor: !readOnlyInheritedRecurringItem && !isAthleteAddedItem && 'pointer' }}>{getName()}</NameText>
                      <IcomoonReact
                        iconSet={iconSet}
                        size={10}
                        icon='gs-arrow-down'
                        color={colors.textSecondary}
                        style={{ minWidth: 10 }}
                      />
                    </NameTextAndDownArrowContainer>
                    )}
                  </>
                )
              ) : (
                content.type === 'session_break' ? (
                  /* Gate the editor instance on !content.preSave so we don't
                   * mount it (and capture a stale string assignedId in the
                   * useRef-stored debounce) before the auto-save returns. */
                  sessionBreakInputOpen && isExpanded && !content.preSave ? (
                    <SessionBreakTable
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      isRecurring={isRecurring}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      setSessionBreakInputOpen={setSessionBreakInputOpen}
                      sessionBreakInputOpen={sessionBreakInputOpen}
                      itemIsHoveredByMouse={itemIsHoveredByMouse}
                      inputBox
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                      numberOfItemsUnderSessionBreak={NumberOfItemsUnderSessionBreak}
                      sessionBreakInputValue={sessionBreakInputValue}
                      setSessionBreakInputValue={setSessionBreakInputValue}
                    />
                  ) : (
                    <>
                      {content.preSave ? (
                        <Shimmer>
                          <ShimmerDescription />
                        </Shimmer>
                      ) : (
                        <NameText
                          isTvMode={isTvMode}
                          style={{ maxWidth: isExpanded && 'fit-content', cursor: !readOnlyInheritedRecurringItem && !isAthleteAddedItem && 'pointer' }}
                          onClick={(e) => {
                            if (isExpanded) {
                              e.stopPropagation();
                            }
                            setSessionBreakInputOpen(true);
                          }}
                        >
                          {`${sessionBreakInputValue || getName()}${NumberOfItemsUnderSessionBreak > 0 ? ` (${NumberOfItemsUnderSessionBreak})` : ''}`}
                        </NameText>
                      )}
                      {/* {only need to render hidden table once for auto save on preSave item} */}
                      {content.preSave && (
                      <SessionBreakTable
                        contentIndex={index}
                        content={content}
                        localAdditionalInfo={localAdditionalInfo}
                        isRecurring={isRecurring}
                        nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                        setSessionBreakInputOpen={setSessionBreakInputOpen}
                        sessionBreakInputOpen={sessionBreakInputOpen}
                        itemIsHoveredByMouse={itemIsHoveredByMouse}
                        inputBox
                        date={effectiveDate}
                        dayNumber={effectiveSelectedProgramDayNumber}
                        numberOfItemsUnderSessionBreak={NumberOfItemsUnderSessionBreak}
                        hidden
                        sessionBreakInputValue={sessionBreakInputValue}
                        setSessionBreakInputValue={setSessionBreakInputValue}
                      />
                      )}
                    </>
                  )
                ) : (
                  <NameText isTvMode={isTvMode} style={{ maxWidth: 'fit-content', cursor: !readOnlyInheritedRecurringItem && !isAthleteAddedItem && 'pointer' }}>{getName()}</NameText>
                )
              )}
            </TextColumn>
            {((!isWeekView && !isAthleteAddedItem && !readOnlyInheritedRecurringItem) || (isWeekView && isDayExpanded && !isAthleteAddedItem && !readOnlyInheritedRecurringItem)) ? (
              <RightBox
                ref={inLineActionsContainerRef}
                onClick={(e) => e.stopPropagation()}
              >
                {(shouldShowQuickActions || isExpanded || content.preSave || isThisItemSupersetPickerOpen) && windowWidth > 575 && (
                <IconBox>
                  {inLineActionsIconDisplayer(inLineActionsObject)}
                </IconBox>
                )}
                <CalendarItemDropdownOptions
                  setAssignedPace={setAssignedPace}
                  setIconOb={setIconOb}
                  handleRemovePresaveItemFromRedux={handleRemovePresaveItemFromRedux}
                  assignedPace={assignedPace}
                  iconOb={iconOb}
                  setIsExpanded={setIsExpanded}
                  isExpanded={isExpanded}
                  expandId={content.assignedId}
                  contentType={typeResolver(content)}
                  exerciseOptions={exerciseOptions}
                  index={index}
                  content={content}
                  localAdditionalInfo={localAdditionalInfo}
                  localDescription={localDescription}
                  isRecurring={isRecurring}
                  isWeekView={isWeekView}
                  effectiveDate={effectiveDate}
                  dayNumber={dayNumber}
                  measure={measure}
                  hideExpandCollapse={!!onPopoverClose}
                  isDragging={isDragging}
                />
                {onPopoverClose && (
                  <>
                    <InLineActionsIconContainer
                      data-tooltip-id={`month-popover-close-${content.assignedId}`}
                      onClick={(e) => {
                        e.stopPropagation();
                        onPopoverClose();
                      }}
                    >
                      <IcomoonReact
                        iconSet={iconSet}
                        size={12}
                        icon='remove'
                        className='inLineActionsIcons'
                      />
                    </InLineActionsIconContainer>
                    <ReactTooltip
                      id={`month-popover-close-${content.assignedId}`}
                      place='top'
                      content='Close'
                      style={{
                        backgroundColor: 'rgba(68, 68, 68, 1)',
                        color: colors.white,
                        fontFamily: 'Nunito Sans',
                        fontSize: '13px',
                        zIndex: 1000,
                      }}
                    />
                  </>
                )}
              </RightBox>
            ) : (
              <RightBoxPlaceholder />
            )}
          </ClickContainer>
          {isExpanded || content.preSave || typeDoesNotExpand() ? (
            <Subtext
              isTvMode={isTvMode}
              style={{ marginLeft: onPopoverClose ? 0 : 7, width: isCalendarItemSavingOrUpdating ? '100%' : 'fit-content' }}
              className='add-info'
            >
              {paceDisplaySection()}
              {getExerciseInfoCategory(content) !== 'none' ? infoEditSection(content) : null}
              {content?.type === 'progression' || content?.typeDescription === 'progression' || content?.type === 'P' || content?.exercise?.type === 'P' ? (
                <Text color={colors.textSecondary} fontSize='12px' style={{ marginBottom: 5 }}>Athlete will be shown the selected step that corresponds to their level.</Text>
              ) : null}
            </Subtext>
          ) : (
            <SubTitle
              isTvMode={isTvMode}
              style={{
                marginLeft: onPopoverClose ? 0 : 7,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                marginRight: 18,
                maxWidth: '100%',
              }}
            >
              {content.additionalInfo && (content.type === 'lift' || content.type === 'L' || content.type === 'T' || content.type === 'tag') ? `${decodeHtmlEntities(content.subTitle)} - ${decodeHtmlEntities(content.additionalInfo)}` : decodeHtmlEntities(content.subTitle) }
            </SubTitle>
          )}
          {!content.preSave ? (
            <ExpandingContainer
                /** this style is important for react virtualize to be able to dynamically expand and collpase items */
              style={{ display: !isExpanded && 'none' }}
              ref={expandingContainerRef}
              isPopover={!!onPopoverClose}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ConditionalScrollContainer ref={contentRef} style={{ overflowX: !typeHasIndividualScrollContainer() && 'scroll' }}>
                {content?.exercise?.type === 'L' ? (
                  flags?.transposedEditTable ? (
                    <ExerciseTableTransposed
                      exerciseOptions={exerciseOptions}
                      isBodyweight={isBodyweight}
                      setIsBodyweight={setIsBodyweight}
                      content={content}
                      index={index}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      isLeftAndRight={isLeftAndRight}
                      trackRepCount={trackRepCount}
                      trackVolumeLoad={trackVolumeLoad}
                      forcePrUpdate={forcePrUpdate}
                      disablePrUpdate={disablePrUpdate}
                      swapDropdownSelectedExercise={selectedOption}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      isRecurring={isRecurring}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  ) : (
                    <ExerciseTable
                      content={content}
                      index={index}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      isLeftAndRight={isLeftAndRight}
                      trackRepCount={trackRepCount}
                      trackVolumeLoad={trackVolumeLoad}
                      forcePrUpdate={forcePrUpdate}
                      disablePrUpdate={disablePrUpdate}
                      swapDropdownSelectedExercise={selectedOption}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      isRecurring={isRecurring}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  )
                ) : null}
                {content?.exercise?.type === 'R' ? (
                  flags?.transposedEditTable ? (
                    <ExerciseTableTransposedSAQC
                      exerciseOptions={exerciseOptions}
                      content={content}
                      index={index}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      swapDropdownSelectedExercise={selectedOption}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      isRecurring={isRecurring}
                      assignedPace={assignedPace}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  ) : (
                    <ExerciseTableSAQC
                      content={content}
                      index={index}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      swapDropdownSelectedExercise={selectedOption}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      isRecurring={isRecurring}
                      assignedPace={assignedPace}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  )
                ) : null}
                {content?.exercise?.type === 'C' ? (
                  flags?.transposedEditTable ? (
                    <ExerciseTableTransposedCircuit
                      exerciseOptions={exerciseOptions}
                      content={content}
                      index={index}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      swapDropdownSelectedExercise={selectedOption}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      isRecurring={isRecurring}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  ) : (
                    <ExerciseTableCircuit
                      content={content}
                      index={index}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      swapDropdownSelectedExercise={selectedOption}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      isRecurring={isRecurring}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  )
                ) : null}
                {content?.exercise?.type === 'S' ? (
                  <QuestionnaireTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    localDescription={localDescription}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'W' ? (
                  <WarmupTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'N' ? (
                  <NoteTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'H' || content?.type === 'health' ? (
                  <HealthTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'CD' ? (
                  <CooldownTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'session_break' ? (
                  <SessionBreakTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    isRecurring={isRecurring}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    checkBoxInput
                    itemIsHoveredByMouse={itemIsHoveredByMouse}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                    numberOfItemsUnderSessionBreak={NumberOfItemsUnderSessionBreak}
                    sessionBreakInputValue={sessionBreakInputValue}
                    setSessionBreakInputValue={setSessionBreakInputValue}
                  />
                ) : null}
                {content?.type === 'rest' ? (
                  <RestTimeTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    isRecurring={isRecurring}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'video' ? (
                  <VideoTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    isRecurring={isRecurring}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'progression' ? (
                  <ProgressionTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    isRecurring={isRecurring}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'tag' ? (
                  flags?.transposedEditTable ? (
                    <TagTableTransposed
                      exerciseOptions={exerciseOptions}
                      isBodyweight={isBodyweight}
                      setIsBodyweight={setIsBodyweight}
                      content={content}
                      index={index}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      isLeftAndRight={isLeftAndRight}
                      trackRepCount={trackRepCount}
                      trackVolumeLoad={trackVolumeLoad}
                      forcePrUpdate={forcePrUpdate}
                      disablePrUpdate={disablePrUpdate}
                      swapDropdownSelectedExercise={selectedOption}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      isRecurring={isRecurring}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  ) : (
                    <TagTable
                      content={content}
                      index={index}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      isLeftAndRight={isLeftAndRight}
                      trackRepCount={trackRepCount}
                      trackVolumeLoad={trackVolumeLoad}
                      forcePrUpdate={forcePrUpdate}
                      disablePrUpdate={disablePrUpdate}
                      swapDropdownSelectedExercise={selectedOption}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      isRecurring={isRecurring}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  )
                ) : null}
              </ConditionalScrollContainer>
            </ExpandingContainer>
          ) : (
            <PreSaveExpandingContainer
              isPopover={!!onPopoverClose}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ConditionalScrollContainer ref={contentRef} style={{ overflowX: !typeHasIndividualScrollContainer() && 'scroll' }}>
                {content?.type === 'L' ? (
                  flags?.transposedEditTable ? (
                    <PreSaveTableTransposed
                      exerciseOptions={exerciseOptions}
                      isBodyweight={isBodyweight}
                      setIsBodyweight={setIsBodyweight}
                      setCoachCompletion={setCoachCompletion}
                      coachCompletion={coachCompletion}
                      isLeftAndRight={isLeftAndRight}
                      setIsLeftAndRight={setIsLeftAndRight}
                      completionOnly={completionOnly}
                      setCompletionOnly={setCompletionOnly}
                      trackRepCount={trackRepCount}
                      setTrackRepCount={setTrackRepCount}
                      trackVolumeLoad={trackVolumeLoad}
                      setTrackVolumeLoad={setTrackVolumeLoad}
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      swapDropdownSelectedExercise={selectedOption}
                      forcePrUpdate={forcePrUpdate}
                      setForcePrUpdate={setForcePrUpdate}
                      disablePrUpdate={disablePrUpdate}
                      setDisablePrUpdate={setDisablePrUpdate}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  ) : (
                    <PreSaveTable
                      setCoachCompletion={setCoachCompletion}
                      coachCompletion={coachCompletion}
                      isLeftAndRight={isLeftAndRight}
                      setIsLeftAndRight={setIsLeftAndRight}
                      completionOnly={completionOnly}
                      setCompletionOnly={setCompletionOnly}
                      trackRepCount={trackRepCount}
                      setTrackRepCount={setTrackRepCount}
                      trackVolumeLoad={trackVolumeLoad}
                      setTrackVolumeLoad={setTrackVolumeLoad}
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      swapDropdownSelectedExercise={selectedOption}
                      forcePrUpdate={forcePrUpdate}
                      setForcePrUpdate={setForcePrUpdate}
                      disablePrUpdate={disablePrUpdate}
                      setDisablePrUpdate={setDisablePrUpdate}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  )
                ) : null}
                {content?.type === 'R' ? (
                  flags?.transposedEditTable ? (
                    <PreSaveTableTransposedSAQC
                      exerciseOptions={exerciseOptions}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      localDescription={localDescription}
                      swapDropdownSelectedExercise={selectedOption}
                      assignedPace={assignedPace}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                      measure={measure}
                    />
                  ) : (
                    <PreSaveTableSAQC
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      localDescription={localDescription}
                      swapDropdownSelectedExercise={selectedOption}
                      assignedPace={assignedPace}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  )
                ) : null}
                {content?.type === 'C' ? (
                  flags?.transposedEditTable ? (
                    <PreSaveTableTransposedCircuit
                      exerciseOptions={exerciseOptions}
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      localDescription={localDescription}
                      swapDropdownSelectedExercise={selectedOption}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                      measure={measure}
                    />
                  ) : (
                    <PreSaveTableCircuit
                      coachCompletion={coachCompletion}
                      completionOnly={completionOnly}
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      localDescription={localDescription}
                      swapDropdownSelectedExercise={selectedOption}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  )
                ) : null}
                {content?.type === 'S' ? (
                  <QuestionnaireTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    localDescription={localDescription}
                    swapDropdownSelectedExercise={selectedOption}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'W' ? (
                  <WarmupTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'N' ? (
                  <NoteTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'H' || content?.type === 'health' ? (
                  <HealthTable
                    // contentIndex={index}
                    // content={content}
                    // localAdditionalInfo={localAdditionalInfo}
                    // date={effectiveDate}
                    // dayNumber={effectiveSelectedProgramDayNumber}
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'CD' ? (
                  <CooldownTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'rest' ? (
                  <PreSaveRestTimeTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'video' ? (
                  <PreSaveVideoTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'T' ? (
                  flags?.transposedEditTable ? (
                    <PreSaveTableTransposed
                      exerciseOptions={exerciseOptions}
                      isBodyweight={isBodyweight}
                      setIsBodyweight={setIsBodyweight}
                      setCoachCompletion={setCoachCompletion}
                      coachCompletion={coachCompletion}
                      isLeftAndRight={isLeftAndRight}
                      setIsLeftAndRight={setIsLeftAndRight}
                      completionOnly={completionOnly}
                      setCompletionOnly={setCompletionOnly}
                      trackRepCount={trackRepCount}
                      setTrackRepCount={setTrackRepCount}
                      trackVolumeLoad={trackVolumeLoad}
                      setTrackVolumeLoad={setTrackVolumeLoad}
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      swapDropdownSelectedExercise={selectedOption}
                      forcePrUpdate={forcePrUpdate}
                      setForcePrUpdate={setForcePrUpdate}
                      disablePrUpdate={disablePrUpdate}
                      setDisablePrUpdate={setDisablePrUpdate}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  ) : (
                    <PreSaveTable
                      setCoachCompletion={setCoachCompletion}
                      coachCompletion={coachCompletion}
                      isLeftAndRight={isLeftAndRight}
                      setIsLeftAndRight={setIsLeftAndRight}
                      completionOnly={completionOnly}
                      setCompletionOnly={setCompletionOnly}
                      trackRepCount={trackRepCount}
                      setTrackRepCount={setTrackRepCount}
                      trackVolumeLoad={trackVolumeLoad}
                      setTrackVolumeLoad={setTrackVolumeLoad}
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      swapDropdownSelectedExercise={selectedOption}
                      forcePrUpdate={forcePrUpdate}
                      setForcePrUpdate={setForcePrUpdate}
                      disablePrUpdate={disablePrUpdate}
                      setDisablePrUpdate={setDisablePrUpdate}
                      measure={measure}
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                    />
                  )
                ) : null}
                {content?.type === 'P' ? (
                  <PreSaveProgressionTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
              </ConditionalScrollContainer>
            </PreSaveExpandingContainer>
          )}
        </LineContainer>
      </ItemRow>
    </Container>
  );
};

DraggableContent.propTypes = {
  content: PropTypes.instanceOf(Object).isRequired,
  isHovered: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  isRecurring: PropTypes.string,
  shouldShowQuickActions: PropTypes.bool,
  isDragging: PropTypes.bool,
  localDescription: PropTypes.string,
  setLocalDescription: PropTypes.func,
  localAdditionalInfo: PropTypes.string,
  setLocalAdditionalInfo: PropTypes.func,
  measure: PropTypes.func,
  itemHoveringOverCurrentItem: PropTypes.bool,
  itemIsHoveredByMouse: PropTypes.bool,
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  checkboxVisible: PropTypes.bool,
  beforeOrAfter: PropTypes.string,
  isWeekView: PropTypes.bool,
  isDayExpanded: PropTypes.bool,
  date: PropTypes.string,
  dayNumber: PropTypes.string,
  onDayExpand: PropTypes.func,
  isAthleteAddedItem: PropTypes.bool,
  readOnlyInheritedRecurringItem: PropTypes.bool,
  athleteAddedItems: PropTypes.arrayOf(
    PropTypes.shape({
      groupingLetter: PropTypes.string,
    }),
  ),
  omitCheckbox: PropTypes.bool,
  onPopoverClose: PropTypes.func,
  flags: PropTypes.shape({
    transposedEditTable: PropTypes.bool,
  }),
  // eslint-disable-next-line react/forbid-prop-types
  dragHandleProps: PropTypes.object,
};

DraggableContent.defaultProps = {
  isRecurring: null,
  shouldShowQuickActions: false,
  isDragging: false,
  localDescription: '',
  localAdditionalInfo: '',
  setLocalDescription: () => {},
  setLocalAdditionalInfo: () => {},
  measure: () => {},
  itemHoveringOverCurrentItem: false,
  itemIsHoveredByMouse: false,
  isExpanded: false,
  setIsExpanded: () => {},
  checkboxVisible: false,
  beforeOrAfter: '',
  isWeekView: false,
  isDayExpanded: false,
  date: null,
  dayNumber: null,
  onDayExpand: () => {},
  isAthleteAddedItem: false,
  readOnlyInheritedRecurringItem: false,
  athleteAddedItems: [],
  omitCheckbox: false,
  onPopoverClose: null,
  flags: {},
  dragHandleProps: null,
};

export default withLDConsumer()(DraggableContent);
